import { Layout, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { CloseIcon, MapsIcon, SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";
import MapsFullScreen from "../maps/MapsFullScreen";
import Geocode from "react-geocode";
import { useState } from "react";

const ModalMaps = (props) => {
  const { t } = useTranslation();
  const [loc, setLoc] = useState()
  // const geocode = () => {
    // Geocode.setApiKey("AIzaSyA8-XM3CcTcdgDTp-ktzPzr0ALnQAO8JCE");
    // Geocode.fromLatLng(props.latitude,props.longitude).then(
    //   (response) => {
    //     const { lat, lng } = response.results[0].geometry.location;
    //     setLoc(response.results[0].formatted_address)
    //     console.log("res", response.results[0].formatted_address);
    //   },
    //   (error) => {
    //     console.error("geo eroer", error);
    //   }
    // );
  return (
    <>
    <Modal
        visible={props.show}
        closable={false}
        centered={true}
        width="2000px"
        footer={null}
      >
      {/* <div
      id='modal-info'
      className={`w-full h-full bg-gray-300 bg-opacity-50 top-0 left-0
     absolute justify-center ${props.show ? '' : 'hidden'} `}
      // onClick={() => onClose()}
      style={{zIndex: 100000000000}}
    > */}
        {/* <div className="flex flex-col justify-center items-center gap-[9px]"> */}
        <Layout.Header
        style={{
          backgroundColor: "white",
          display: "flex",
          justifyContent: "right",
          zIndex: 1,
          boxShadow: "0px 4px 12px -4px rgba(0, 0, 0, 0.15)",
          height:"90px",
        }}
      >
        <div className="mt-3 flex">
          <img className="h-10" src={MapsIcon} alt="map"/>
          <div>
            <div className="text-red-100 mt-[-5px] font-bold ml-2 text-xl">{props.address}</div>
            <div className="text-red-100 mt-[-20px] font-semibold ml-2">{props.loc}</div>
          </div>
        </div>
        <div className="mt-6 flex justify-end ml-[600px] mr-2 cursor-pointer" onClick={()=>props.onClose()}>
          <img className="h-6" src={CloseIcon} alt="map"/>
          </div>
      </Layout.Header>
      <div >
      </div>
      <MapsFullScreen
          lat={props?.latitude}
          long={props?.longitude}
          />
      {/* </div> */}
      </Modal>
    </>
  );
};
export default ModalMaps;
